module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '5pgduv6u',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
